module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_84-7addc1cbc5cd2f45e582851e070cb9e9.png";